import React from 'react';

import { useFilter } from 'src/hooks/common';

import { DashboardReportsMetrics } from './DashboardReportsMetrics';

interface DashboardReportsPeoProps {
  createdAtCompany: string;
  loading?: boolean;
}
export const DashboardReportsPeo: React.FC<DashboardReportsPeoProps> = ({
  createdAtCompany,
  loading,
}) => {
  const { filter } = useFilter();

  const employerIds = (filter.employerIds ?? []) as string[];

  return (
    <DashboardReportsMetrics
      employerIds={employerIds}
      createdAtCompany={createdAtCompany}
      loading={loading}
    />
  );
};
